import {
	concat,
	filter,
	forEach,
	includes,
	isEmpty,
	isNil,
	map,
} from 'lodash-es';
import type { EventType, InboxFilters, NotificationFilters } from '../types';

export function getEventsFilter(
	eventTypes: EventType[],
	events: string,
	isInclusive: boolean
) {
	// Automatically treat grouped keys (those starting with "notify_") as inclusive when the
	// caller did not explicitly request inclusive mode. This lets URLs such as
	// `?events=notify_requests` work without needing `inclusive=true`.

	if (!isInclusive && !isEmpty(events)) {
		const selectedValues = events.split(',');
		const areGroupedKeys = selectedValues.every((v) => v.startsWith('notify_'));
		if (areGroupedKeys) {
			isInclusive = true;
		}
	}

	const eventFilters = concat(map(eventTypes, 'values')).join(',');

	if (isEmpty(events) || isNil(events)) {
		return eventFilters;
	}

	if (!isInclusive) {
		const eventsFilterArr = eventFilters.split(',');
		const exclusiveFilters: string[] = [];

		forEach(eventsFilterArr, (event) => {
			if (!includes(events.split(','), event)) {
				exclusiveFilters.push(event);
			}
		});

		return exclusiveFilters.join(',');
	}

	const eventsArr = events.split(',');
	const eventTypeCategories = filter(eventTypes, (type: EventType) =>
		includes(eventsArr, type.value)
	);
	return concat(map(eventTypeCategories, 'values')).join(',');
}

export const getInboxFiltersFromUrl = (
	params: URLSearchParams
): InboxFilters => ({
	searchTerm: params.get('searchTerm') || '',
	page: parseInt(params.get('page') || '1', 10),
	events: params.get('events') || '',
	isInclusive: params.get('inclusive') === 'true',
	selectedId: params.get('id') || '',
});

export function getFilters(
	eventTypes: EventType[],
	events: string,
	searchTerm: string,
	isInclusive: boolean,
	showRead: boolean
): NotificationFilters {
	const eventFilters = getEventsFilter(eventTypes, events, isInclusive);

	return {
		events: eventFilters,
		search_term: searchTerm,
		read: showRead,
	};
}

export function getNotificationType(
	eventTypes: EventType[],
	event: string
): 'notifications' | 'tasks' {
	const type: 'notifications' | 'tasks' = 'notifications';

	const foundEventType = eventTypes.find((task) =>
		includes(task.values, event)
	);

	if (foundEventType && foundEventType.isTask) {
		return 'tasks';
	}

	return type;
}
